<template>
    <div class="msg-subscr-msanage">
        <div class="hint block mb10">
            <div class="title">温馨提示</div>
            <p>逐条检查：一条一条的检查，因数据较多花费时间较长</p>
            <p>逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长</p>
            <p>导入excel文件的单元格格式推荐使用常规或文本</p>
        </div>
        <div class="message-body">
            <ul class="native-table">
                <li class="table-tr">
                    <div class="table-th" style="text-align: left">列名</div>
                    <div class="table-th" style="width: 120px">是否必填</div>
                    <div class="table-th" style="text-align: left">其他要求</div>
                    <div class="table-th" style="text-align: left">正确示例</div>
                    <div class="table-th">不符合要求的结果</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">批次号</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择或手动输入</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">资产编号</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择或手动输入(注意：单品式管理的资产入库数量大于1的时候，资产编号不能自动生成，保存的时候以后台系统生成为主)</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">验证不通过</div>
                </li>
                <!-- AssetType == -1; -->
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">定义编码</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr" v-if="assetType != 2 && assetType != -1">
                    <div class="table-td" style="text-align: left">统一商品代码(UPC)</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">-</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">{{assetType != 2 ? '资产' : '耗材描述全'}}名称</div>
                    <div class="table-td">{{assetType != 2 ? '是' : '-'}}</div>
                    <div class="table-td" style="text-align: left">不能超过60个字符，{{assetType != 2 ? '从定义带入以定义为准' : '不填写从定义带入'}}</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">此行无效</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">业务单元</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必须与导入业务单元一致</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">此行无效</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">所属部门</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">必须与导入所属部门一致</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">此行无效</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">启用日期</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">格式 yyyy-MM-dd</div>
                    <div class="table-td" style="text-align: left">2019-01-01</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <!--<li class="table-tr" v-if="assetType != 2">-->
                <!--<div class="table-td" style="text-align: left">资产分类</div>-->
                <!--<div class="table-td">-</div>-->
                <!--<div class="table-td" style="text-align: left">资产分类可为空（从定义带入以定义为准）</div>-->
                <!--<div class="table-td" style="text-align: left"></div>-->
                <!--<div class="table-td">此行无效</div>-->
                <!--</li>-->
                <!--<li class="table-tr" v-if="assetType != 2">-->
                <!--<div class="table-td" style="text-align: left">资产分类编码</div>-->
                <!--<div class="table-td">-</div>-->
                <!--<div class="table-td" style="text-align: left">资产分类编码可为空（从定义带入以定义为准）</div>-->
                <!--<div class="table-td" style="text-align: left"></div>-->
                <!--<div class="table-td">此行无效</div>-->
                <!--</li>-->
                <!--<li class="table-tr" v-if="assetType != 2">-->
                <!--<div class="table-td" style="text-align: left">资产品牌</div>-->
                <!--<div class="table-td">-</div>-->
                <!--<div class="table-td" style="text-align: left">资产品牌可为空（从定义带入以定义为准）</div>-->
                <!--<div class="table-td" style="text-align: left"></div>-->
                <!--<div class="table-td">此行无效</div>-->
                <!--</li>-->
                <!--<li class="table-tr" v-if="assetType != 2">-->
                <!--<div class="table-td" style="text-align: left">资产品牌编码</div>-->
                <!--<div class="table-td">-</div>-->
                <!--<div class="table-td" style="text-align: left">资产品牌编码可为空（从定义带入以定义为准）</div>-->
                <!--<div class="table-td" style="text-align: left"></div>-->
                <!--<div class="table-td">此行无效</div>-->
                <!--</li>-->
                <li class="table-tr" v-if="assetType == 2 || assetType == -1">
                    <div class="table-td" style="text-align: left">商品分类</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">商品分类不可为空（从定义带入以定义为准）</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">此行无效</div>
                </li>
                <li class="table-tr" v-if="assetType == 2 || assetType == -1">
                    <div class="table-td" style="text-align: left">商品品牌</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">从定义带入以定义为准（如果不选择任何品牌，系统会默认为无名公共）</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">此行无效</div>
                </li>
                <li class="table-tr" v-if="assetType == 2 || assetType == -1">
                    <div class="table-td" style="text-align: left">型号</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">从定义带入以定义为准</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">验证不通过</div>
                </li>
                <li class="table-tr" v-if="assetType == 2 || assetType == -1">
                    <div class="table-td" style="text-align: left">规格</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">从定义带入以定义为准</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">验证不通过</div>
                </li>
                <!--<li class="table-tr" v-if="assetType != 2">-->
                <!--<div class="table-td" style="text-align: left">规格编码</div>-->
                <!--<div class="table-td">-</div>-->
                <!--<div class="table-td" style="text-align: left">生成定义的时候可作为定义编码</div>-->
                <!--<div class="table-td" style="text-align: left"></div>-->
                <!--<div class="table-td"></div>-->
                <!--</li>-->
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">供商统一社会信用码</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">-</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">厂商序列号</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">商户内唯一，如填写厂商序列号，数量必须为1（针对单品）</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">是否批量</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">不填写默认为否，从定义带入以定义为准</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">检验设备</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">不填写默认为否</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">需巡查设备</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">不填写默认为否</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">需保养设备</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">不填写默认为否</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">是否可出租</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">不填写默认为否</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">收货日期</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">格式 yyyy-MM-dd</div>
                    <div class="table-td" style="text-align: left">2019-01-01</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">数量</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">必须是大于0的整数,不能为小数</div>
                    <div class="table-td" style="text-align: left">1、2、3</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <!--<li class="table-tr" v-if="assetType != 2">-->
                <!--<div class="table-td" style="text-align: left">不入账</div>-->
                <!--<div class="table-td">-</div>-->
                <!--<div class="table-td" style="text-align: left">是否不入账，忽略财务方面内容</div>-->
                <!--<div class="table-td" style="text-align: left">-</div>-->
                <!--<div class="table-td">无法解析文件</div>-->
                <!--</li>-->
                <li class="table-tr" v-if="assetType == 2 || assetType == -1">
                    <div class="table-td" style="text-align: left">单位</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">系统对每类资产有一个默认分类，不填写的情况下直接使用此单位。商户应对每类每批次定一个固定单位</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td"></div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">质保期（月）</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">必须是大于0的整数,不能为小数</div>
                    <div class="table-td" style="text-align: left">1、2、3</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr" v-if="assetType != -1">
                    <div class="table-td" style="text-align: left">入账方式</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择，或者导入之后，后续进行手工操作</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2 && assetType != -1">
                    <div class="table-td" style="text-align: left">原值(元)</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">必须是大于等于0的数字,可以为小数。包含（含税单价、物流单价、安装单价）</div>
                    <div class="table-td" style="text-align: left">24.67</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr" v-if="assetType != 2 && assetType != -1">
                    <div class="table-td" style="text-align: left">入账日期</div>
                    <div class="table-td">是</div>
                    <div class="table-td" style="text-align: left">格式 yyyy-MM-dd</div>
                    <div class="table-td" style="text-align: left">2019-01-01</div>
                    <div class="table-td">无法解析文件、验证不通过</div>
                </li>
                <li class="table-tr" v-if="assetType != 2 && assetType != -1">
                    <div class="table-td" style="text-align: left">购置日期</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">格式 yyyy-MM-dd</div>
                    <div class="table-td" style="text-align: left">2019-01-01</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr" v-if="assetType != 2 && assetType != -1">
                    <div class="table-td" style="text-align: left">折旧起算日期</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">格式 yyyy-MM-dd</div>
                    <div class="table-td" style="text-align: left">2019-01-01</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr" v-if="assetType != 2 && assetType != -1">
                    <div class="table-td" style="text-align: left">累计折旧值(元)</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">单个的累计折旧值，必须是大于0的整数，可以为小数</div>
                    <div class="table-td" style="text-align: left">34</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr" v-if="assetType != 2 && assetType != -1">
                    <div class="table-td" style="text-align: left">最后折旧月份</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">格式 yyyy-MM，截止目前已经折旧的月份</div>
                    <div class="table-td" style="text-align: left">2019-01</div>
                    <div class="table-td">无法解析文件</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">责任部门</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择，或者导入之后，后续进行手工操作</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">责任部门编码</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择，或者导入之后，后续进行手工操作</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">责任人</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择，或者导入之后，后续进行手工操作</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">责任人编码</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">可在系统中进行选择，或者导入之后，后续进行手工操作</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr">
                    <div class="table-td" style="text-align: left">备注</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">-</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">备注1</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">-</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">备注2</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">-</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>
                <li class="table-tr" v-if="assetType != 2">
                    <div class="table-td" style="text-align: left">备注3</div>
                    <div class="table-td">-</div>
                    <div class="table-td" style="text-align: left">-</div>
                    <div class="table-td" style="text-align: left"></div>
                    <div class="table-td">-</div>
                </li>

            </ul>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-shop-device-format-expl',
        desc: '资产导入文件格式说明',
        props: ['assetType'],
        data: function () {
            return {}
        },
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceFormatExpl.vue